import {Component, Input} from '@angular/core';
import {EmailService} from '../../../services/email.service';
import {FilterStateItem, FilterRecipientsItem} from '../../../services/filter-recipients';
import {ConstantsService} from '../../../services/constants.service';

declare const swal: any;

@Component({
    selector: 'recipients-filter-view',
    templateUrl: './recipients-filter-view.component.html',
    styleUrls: ['./recipients-filter-view.component.scss']
})
export class RecipientsFilterViewComponent {
    @Input() recipientFilterState: FilterStateItem[] = [];
    @Input() inViewModal = false;

    constructor(
        public es: EmailService,
    ) {}

    showChoiceRecipientsModal() {
        if (!this.inViewModal && this.es.filterRecipients) {
            this.es.isChoiceRecipientsModalShow = true;
        }
    }

    removeRecipientsBlock(i: number) {
        swal(
            ConstantsService.getSwalConfig('Delete Recipients'),
            () => {
                const filterIndex = this.es.filterRecipients.filters.findIndex(f => f.buildingId == this.recipientFilterState[i].buildingId);
                this.es.filterRecipients.filteredResidents.forEach(
                    fr => {
                        if(this.recipientFilterState[i].checkedResidents.indexOf(fr.id) !== -1)
                            fr.checked = false;
                    }
                );
                this.es.filterRecipients.residents.forEach(
                    fr => {
                        if(this.recipientFilterState[i].checkedResidents.indexOf(fr.id) !== -1)
                            fr.checked = false;
                    }
                );
                this.recipientFilterState.splice(i, 1);

                //Clearing the filter checkboxes for the removed building.
                const buildingId = this.es.filterRecipients.filters[filterIndex].buildingId;
                const buildingName = this.es.filterRecipients.filters[filterIndex].buildingName;
                const parent = this.es.filterRecipients.filters[filterIndex].parent;
                const settings = this.es.filterRecipients.filters[filterIndex].cNSettings;
                this.es.filterRecipients.filters[filterIndex] = new FilterRecipientsItem(buildingId, buildingName, this.es.groups, parent, settings);

                if(this.recipientFilterState.length == 0) {
                    this.es.filterRecipients.ignoreWaiverSettings = -1;
                    this.es.filterRecipients.filteredResidents = [];
                    this.es.filterRecipients.residents = [];
                }
            }
        );
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/email-merge/recipients-filter-view/recipients-filter-view.component.ts